const COMBINE = 0
const REMOVE = 1

export const bitwiseOperators = {
  COMBINE,
  REMOVE,
}
